// Initialize environment configuration first
import { setupViteEnv } from '@skin-seoul/env-utils/vite';
import { mountComponents, unmountAllComponents } from './core/mount';
import { ConfigReader } from './config/configReader';

// Get build-time injected environment config
declare const ENV_CONFIG: Record<string, string>;

// Inject environment variables into globalThis for universal compatibility
const envConfig = typeof ENV_CONFIG !== 'undefined' ? ENV_CONFIG : undefined;
setupViteEnv(envConfig);

// Override server origin using runtime hostname logic
const runtimeServerOrigin = ConfigReader.getApiDomain();
if (typeof globalThis !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).__ENV = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(globalThis as any).__ENV,
    NEXT_PUBLIC_ENV_SERVER_ORIGIN: runtimeServerOrigin,
  };
  console.info('[reactshortcode] Runtime NEXT_PUBLIC_ENV_SERVER_ORIGIN set to', runtimeServerOrigin);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountComponents);
} else {
  mountComponents();
}

const unmountButton = document.getElementById('unmountButton');
if (unmountButton) {
  unmountButton.addEventListener('click', unmountAllComponents);
}

export { mountComponents, unmountAllComponents };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).SkinSeoulReactShortcode = {
  initialize: mountComponents,
  unmountAll: unmountAllComponents,
};
